//@ts-ignore
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { globalJump } from '@/utils/utils';

import styles from './index.less';

const ModelFlexList = (props: any) => {
  const { renderData } = props;

  return renderData ? (
    <div>
      <div className={styles.flex_box}>
        {renderData.map((item: any) => {
          return (
            <div
              key={item.assetId || item.id || item.elementId}
              className={styles.flex_item}
              onClick={() => globalJump(item)}
            >
              {item.tagImage && (
                <span
                  style={{
                    position: 'absolute',
                    right: '0',
                    top: '0',
                    display: 'inline-block',
                    width: '0.52rem',
                    height: '0.28rem',
                    backgroundImage: `url(${item.tagImage})`,
                    backgroundSize: '100% 100%',
                  }}
                ></span>
              )}
              <img
                data-src={item.assetImg || item.image || item.contentImage}
                className="lazyload"
              />
              <p title={item.assetName || item.name || item.title}>
                {item.assetName || item.name || item.title}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default ModelFlexList;
